import {reactive} from "vue";

const store = reactive({
    task: {}
});

export const useGeneralInfoStore = () => store as any;
